/** The regions that sign road distance in miles. By region, not language: a Spanish page in
 *  the United States reads miles, an English page in Canada kilometres. */
const MILE_REGIONS = new Set(['US', 'GB'])

export const measuresRoadsInMiles = (locale: string) =>
    MILE_REGIONS.has(new Intl.Locale(locale).maximize().region ?? '')
